import React from 'react';
import { Box, Modal, Typography, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';

import { ICreateBrandingModalProps } from './interfaces';
import { useStyles } from './styles';

const CreateBrandingModal = ({
  open,
  onClose,
  onStartFromScratch,
  onCloneFromExisting,
  hasExistingBrandings = false,
}: ICreateBrandingModalProps) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const canClone = hasExistingBrandings;

  return (
    <Modal open={open} onClose={onClose} sx={classes.modalRoot}>
      <Box sx={classes.createContainer}>
        <Box sx={classes.createHeader}>
          <Typography sx={classes.createTitle}>
            {translate('adminToolbox.createNewBranding', 'Create new configuration')}
          </Typography>
          <IconButton onClick={onClose} sx={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={classes.cardsContainer}>
          <Box sx={classes.cardPrimary} onClick={onStartFromScratch}>
            <Box sx={classes.cardIconWrapper}>
              <EditIcon sx={classes.cardIcon} />
            </Box>
            <Typography sx={classes.cardTitle}>
              {translate('adminToolbox.startFromScratch', 'Start from scratch')}
            </Typography>
            <Typography sx={classes.cardDescription}>
              {translate(
                'adminToolbox.startFromScratchDesc',
                'You will place all assets from your device and customize brand new spot customizations',
              )}
            </Typography>
          </Box>

          <Box
            sx={[
              classes.cardSecondary,
              !canClone && classes.cardSecondaryDisabled,
            ]}
            onClick={canClone ? onCloneFromExisting : undefined}
          >
            <Box sx={classes.cardIconWrapperSecondary}>
              <ContentCopyIcon sx={classes.cardIcon} />
            </Box>
            <Typography sx={classes.cardTitle}>
              {translate(
                'adminToolbox.cloneFromExisting',
                'Clone from existing',
              )}
            </Typography>
            <Typography sx={classes.cardDescription}>
              {translate(
                'adminToolbox.cloneFromExistingDesc',
                'You will be using part of an existing environment. A configuration pack will be cloned and you will be getting some of the customizations',
              )}
            </Typography>
          </Box>
        </Box>

        <Box sx={classes.createFooter}>
          <Button onClick={onClose} sx={classes.cancelButtonFull}>
            {translate('common.cancel', 'Cancel')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateBrandingModal;
